import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-invesor-architect-table',
  templateUrl: './invesor-architect-table.component.html',
  styleUrls: ['./invesor-architect-table.component.css'],
})
export class InvesorArchitectTableComponent implements OnInit {
  constructor() {}
  // THIS COMPONENT IS CHILD COMPONENT OF INVESTOR ARCHITECT TO SHOW TABLE OF EQUITY ALLOCATION BALANCES, BECAUSE WE NEED THIS FOR PRINTING ALSO TO SHOW 10 YEARS RECORDS

  // DECLARATION OF INPUT,OUTPUT VARIABLES TO COMMUNICATE B/W PARENT AND CHILD
  @Input() parentObject: any = {};

  @Input() diffHeaderInvestor: boolean;

  @Input() projectName: string;

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/invesor-architect-table/invesor-architect-table.component.ts